import { Check, HardHat, Buildings, Calculator, ShieldStar, UserFocus } from "@phosphor-icons/react";

/** Small multi-select — choose one or many team members (any role). */
const ROLE_META = {
  admin: { label: "Gérant", color: "#F59E0B", Icon: ShieldStar },
  associate: { label: "Associé", color: "#8B5CF6", Icon: Buildings },
  compta: { label: "Compta", color: "#06B6D4", Icon: Calculator },
  technician: { label: "Tech", color: "#005CFF", Icon: HardHat },
  external: { label: "Externe", color: "#94A3B8", Icon: UserFocus },
};

export default function AssigneesPicker({ team, value = [], onChange, testid = "assignees-picker" }) {
  const active = (team || []).filter((u) => u.is_active !== false);
  const toggle = (id) => {
    const set = new Set(value || []);
    if (set.has(id)) set.delete(id);
    else set.add(id);
    onChange(Array.from(set));
  };
  if (active.length === 0) {
    return <div className="text-[11px] text-white/40 italic">Aucun équipier actif</div>;
  }
  return (
    <div className="flex flex-wrap gap-1.5" data-testid={testid}>
      {active.map((u) => {
        const meta = ROLE_META[u.role] || ROLE_META.technician;
        const on = (value || []).includes(u.id);
        const initials = (u.name || "?").split(" ").map((s) => s[0]).join("").slice(0, 2).toUpperCase();
        return (
          <button
            key={u.id}
            type="button"
            onClick={() => toggle(u.id)}
            className={`text-xs px-2.5 py-1.5 rounded-full flex items-center gap-1.5 border transition-colors ${
              on
                ? "text-white"
                : "bg-white/[0.03] border-white/10 text-white/70 hover:border-white/30"
            }`}
            style={on ? { background: meta.color + "33", borderColor: meta.color, color: "#fff" } : {}}
            data-testid={`${testid}-${u.id}`}
            title={`${u.name} — ${meta.label}`}
          >
            <span
              className="w-5 h-5 rounded-full flex items-center justify-center text-[9px] font-bold shrink-0"
              style={{ background: (u.color || meta.color) + "AA", color: "#fff" }}
            >
              {initials}
            </span>
            <span className="truncate max-w-[110px]">{u.name}</span>
            <span
              className="text-[8px] uppercase tracking-widest px-1 py-px rounded-full"
              style={{ background: meta.color + "33", color: meta.color }}
            >
              {meta.label}
            </span>
            {on && <Check size={11} weight="bold" />}
          </button>
        );
      })}
    </div>
  );
}
